import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectOpenNetworkRegistrationsListItems, selectOpenNetworkRegistrationsTriggerItem } from "../../../../redux/open-network-registrations/selector";
import { openNetworkRegistrations } from "../../../../redux/open-network-registrations/action";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Popup from "../../../../common/components/popup";
import { toast } from "react-toastify";
import storePersist from "../../../../redux/storePersist";
import * as R from 'ramda';


const OpenNetworkRegistrations = () => {
  const [selectedRow, setSelectedRow] = useState<any>(null);
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showPopup, setShowPopup] = useState<boolean>();

  const statesItems = storePersist?.get("states")?.current?.items || [];
  const countriesItems = storePersist?.get("countries")?.current?.items || [];

  const [stateValues, setStateValues] = useState<any[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(null);

  // ✅ Filter states based on selected country (no API call)
  const handleFilterToStates = (countryId: number | null) => {
    if (countryId) {
      const filterStates: any = R.filter(
        (value: any) => value.CountryId === countryId,
        statesItems
      );
      setStateValues(filterStates.length ? filterStates : statesItems);
    } else {
      setStateValues([]);
    }
    setSelectedCountryId(countryId);
  };

    const openNetworkRegistrationsItems = useSelector(selectOpenNetworkRegistrationsListItems)
    const openNetworkRegistrationsTriggerData = useSelector(selectOpenNetworkRegistrationsTriggerItem)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'BusinessName', headerName: 'Business Name',searchField: 'subscriber_id', filter: true,
            filterType: 'text'},
          { field: 'subscriber_id', headerName: 'subscriber Id',searchField: 'subscriber_id', filter: true,
            filterType: 'text'},
          { field: 'subscriber_url', headerName: 'Subscriber URL' ,searchField: 'subscriber_url', filter: true,
            filterType: 'text'},
          { field: 'domain', headerName: 'Domain Name',searchField: 'domain', filter: true,
            filterType: 'text' },
          { field: 'type', headerName: 'Type',searchField: 'type', filter: true,
            filterType: 'text' },
          { field: 'country', headerName: 'country' ,searchField: 'country', filter: true,
            filterType: 'text'},
          { field: 'valid_from', headerName: 'Valid From' , isDateValueFormat:true},
          { field: 'valid_until', headerName: 'Valid Until', isDateValueFormat:true },
          { field: 'IsAddToLocalDBNPRegistration', headerName: 'Add to Global DBNP Registry' , cellRenderer: 'yesNoRenderer',
            searchField: 'IsAddToLocalDBNPRegistration', filter: true,
            filterType: 'boolean'
          },
        ]);
      }
      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
      
          }}))
      }
    
      const handleReloadData = () => {
        dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const fetchOpenNetworkRegistrations=()=>{
        dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleAddToLocalDbnpRegistry=(data: any)=>{
        dispatch(openNetworkRegistrations.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/add-to-global-dbnp-registry`,entity:'openNetworkRegistrations',jsonData:{
   
          Records: [
            { 
              Id: data?.Id
          } 
          ]
      }})).then(() => {
        dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
        
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
      
          }}))
      
        })
      }


      // const handleEnableOpenNetworkRegistry = async (data: any) => {
      //   // console.log('handleEnableOpenNetworkRegistry', data)
      //   let payload: any = {}
      //   switch(data?.type?.toUpperCase()){
      //     case 'BAP':
      //       payload = {
      //         "context": {
      //           "domain": data?.domain,
      //           "core_version": data?.core_version || '1.2.0',
      //           "bap_id": data?.subscriber_id,
      //           "bap_uri": data?.subscriber_url,
      //           // "bap_id": 'ondc-api.nobrokerhood.com',
      //           // "bap_uri": 'https://ondc-api.nobrokerhood.com',
      //           "bpp_id": process.env.REACT_APP_API_URL === 'ai' ? 'bpp.dbs.digiit.ai': 'preprod-bpp.dbs.digiit.io',
      //           "bpp_uri": process.env.REACT_APP_API_URL === 'ai' ? 'https://bpp.dbs.digiit.ai': "https://preprod-bpp.dbs.digiit.io",
      //           "city": data?.city,
      //           "country": data?.country,
      //           "action": "info", 
      //           "transaction_id": uuidv4(),
      //           "message_id": uuidv4(),
      //           "timestamp": moment.utc(),
      //           "ttl": "PT30S"
      //         },
      //         "message": {
      //           "intent": {
      //             "descriptor": {
      //               "code": "info"
      //             }
      //           }
      //         }
      //       }        
      //       break;
      //     case 'BPP':
      //       toast(`Registration of BPP is not enabled currently.`)
      //       return;
      //       // payload = {
      //       //   "context": {
      //       //     "domain": data?.domain,
      //       //     "core_version": data?.core_version || '1.2.0',
      //       //     "bpp_id": data?.subscriber_id,
      //       //     "bpp_uri": data?.subscriber_url,
      //       //     "bap_id": "",
      //       //     "bap_uri": "",
      //       //     // "bap_id": process.env.REACT_APP_API_URL === 'ai' ? 'bpp.dbs.digiit.ai': 'preprod-bpp.dbs.digiit.io',
      //       //     // "bap_uri": process.env.REACT_APP_API_URL === 'ai' ? 'https://bpp.dbs.digiit.ai': "https://preprod-bpp.dbs.digiit.io",
      //       //     "city": data?.city,
      //       //     "country": data?.country,
      //       //     "action": "info", 
      //       //     "transaction_id": uuidv4(),
      //       //     "message_id": uuidv4(),
      //       //     "timestamp": moment.utc(),
      //       //     "ttl": "PT30S"
      //       //   },
      //       //   "message": {
      //       //     "intent": {
      //       //       "descriptor": {
      //       //         "code": "info"
      //       //       }
      //       //     }
      //       //   }
      //       // }
      //       // break;
      // }
      //   await dispatch(openNetworkRegistrations.resetAction({ actionType: 'trigger' }))      
      //   dispatch(openNetworkRegistrations.trigger({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/info`, entity:'openNetworkRegistrations',
      //   jsonData:{   
      //     Records: [
      //       payload
      //     ]
      // }}))
      // }

      const closePopup = () => {
        setShowPopup(false);
      }

      
        const handleManuallyEnableOpenNetworkRegistry = (rowData: any) => {
          setSelectedRow(rowData);
          setShowPopup(true);
        };
      

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const payload = {
      Id: selectedRow?.Id,
      BusinessName: formData.get("BusinessName") as string,
      MailId: formData.get("MailId") as string,
      PhoneNumber: formData.get("PhoneNumber") as string,
      address_of_authorisedSignatory: formData.get("address_of_authorisedSignatory") as string,
      gps: formData.get("gps") as string,
      city: formData.get("city") as string,
       CountryId: Number(formData.get("CountryId")),
     StateProvinceId: Number(formData.get("StateProvinceId")),
      RegConfigPan: {
        name_as_per_pan: formData.get("name_as_per_pan") as string,
        pan_no: formData.get("pan_no") as string,
        date_of_incorporation: formData.get("date_of_incorporation") as string
      },
      RegConfigGst: {
        legal_entity_name: formData.get("legal_entity_name") as string,
        business_address: formData.get("business_address") as string,
        city_code: formData.getAll("city_code").filter(c => c) as string[],
       
        gst_no: formData.get("gst_no") as string
      }
    };

    dispatch(openNetworkRegistrations.update({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations`,
      entity: 'openNetworkRegistrations',
      jsonData: { 
        Context: {},Records: [payload] }
    })).then(() => {
      // toast("Registry manually enabled successfully");
      setShowPopup(false);
      fetchOpenNetworkRegistrations();
    });
  };

      const handleEdit=(data: any)=>{
       navigate(`${data.Id}`)
      }

      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
            <title>Sync</title>
            <path 
              d="M12 2v2a8 8 0 1 1-7.11 11H2a10 10 0 1 0 10-10zM12 22v-2a8 8 0 1 1 7.11-11H22a10 10 0 1 0-10 10z" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round" 
            />
          </svg>,
          callback: () => handlesync(),
        },
       {
        svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <title>Reload</title>
        <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
      },
      ];

	useEffect(() => {
        createColumnDefs()
        fetchOpenNetworkRegistrations()
	}, [pageData,pageSize])

  useEffect(() => {
    console.log('openNetworkRegistrationsTriggerData', openNetworkRegistrationsTriggerData)
    if(openNetworkRegistrationsTriggerData?.isSuccess){
      toast(`Registration initiated successfully`)
      dispatch(openNetworkRegistrations.resetAction({ actionType: 'trigger' }))      
    }
  }, [openNetworkRegistrationsTriggerData]);

  const handleDelete=(data: any)=>{
    dispatch(openNetworkRegistrations.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/delete`,
      entity: 'openNetworkRegistrations',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }

  const handlesync = async () => {
    dispatch(openNetworkRegistrations.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/sync`,entity:'openNetworkRegistrations',jsonData:{
   Context:{},
    Records: [
      { 
        
    } 
    ]
}})).then(() => {
  dispatch(openNetworkRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,entity:'openNetworkRegistrations',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",

    }}))

  })
}

useEffect(() => {
  dispatch(openNetworkRegistrations.resetAction({ actionType: 'trigger' }))      
}, []);
  return (
    <>
{showPopup && (
  <Popup onClose={closePopup}>
    <div className="w-[450px] max-h-[85vh]">
      <form
        onSubmit={handleSubmit}
        className="p-4 space-y-3"
      >
        <h2 className="text-lg font-bold mb-4">Enable Open Network Registry</h2>

        {/* Top-level fields */}
        <input name="BusinessName" placeholder="Business Name" className="border rounded px-3 py-2 w-full" />
        <input name="MailId" type="email" placeholder="Email" className="border rounded px-3 py-2 w-full" />
        <input name="PhoneNumber" placeholder="Phone Number" className="border rounded px-3 py-2 w-full" />
        <input name="address_of_authorisedSignatory" placeholder="Authorized Signatory Address" className="border rounded px-3 py-2 w-full" />
        <input name="gps" placeholder="GPS" className="border rounded px-3 py-2 w-full" />
          <input name="city" placeholder="City" className="border rounded px-3 py-2 w-full" />
         {/* ✅ Country Dropdown (from storePersist) */}
              <select
                name="CountryId"
                className="border rounded px-3 py-2 w-full"
                onChange={(e) =>
                  handleFilterToStates(Number(e.target.value) || null)
                }
                required
              >
                <option value="">Choose Country</option>
                {countriesItems.map((country: any) => (
                  <option key={country.Id} value={country.Id}>
                    {country.Name}
                  </option>
                ))}
              </select>

              {/* ✅ State Dropdown (filtered locally) */}
              <select
                name="StateProvinceId"
                className="border rounded px-3 py-2 w-full"
                disabled={!selectedCountryId}
                required
              >
                <option value="">Choose State</option>
                {stateValues.map((state: any) => (
                  <option key={state.Id} value={state.Id}>
                    {state.Name}
                  </option>
                ))}
              </select>
        {/* RegConfigPan section */}
        <h3 className="font-semibold mt-4">PAN Details</h3>
        <input name="name_as_per_pan" placeholder="Name as per PAN" className="border rounded px-3 py-2 w-full" />
        <input name="pan_no" placeholder="PAN Number" className="border rounded px-3 py-2 w-full" />
        <input name="date_of_incorporation" type="date" placeholder="Date of Incorporation" className="border rounded px-3 py-2 w-full" />

        {/* RegConfigGst section */}
        <h3 className="font-semibold mt-4">GST Details</h3>
        <input name="legal_entity_name" placeholder="Legal Entity Name" className="border rounded px-3 py-2 w-full" />
        <input name="business_address" placeholder="Business Address" className="border rounded px-3 py-2 w-full" />
       <input name="city_code" placeholder="City Code" className="border rounded px-3 py-2 w-full" />

        <input name="gst_no" placeholder="GST Number" className="border rounded px-3 py-2 w-full" />

        {/* Buttons */}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={closePopup}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </Popup>
)}


      {openNetworkRegistrationsItems?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} 
          columnData={columnDefs} 
          rowData={openNetworkRegistrationsItems?.result?.items} 
          setPageData={setPageData}
          paginationData={openNetworkRegistrationsItems?.result?.pagination} 
          additionButtons={additionButtons}
          onEdit={handleEdit} 
          IsActionButton={true} 
          setPageSize={setPageSize}
          handleAddToLocalDbnpRegistry={handleAddToLocalDbnpRegistry}
          // handleEnableOpenNetworkRegistry={handleEnableOpenNetworkRegistry}
          handleManuallyEnableOpenNetworkRegistry={handleManuallyEnableOpenNetworkRegistry}
          headingName="Open Network Registrations" />

      }
    </>
  );
};

export default OpenNetworkRegistrations;


